import actionFe from 'utils/mw/actionFe.util';

export const feSetClientProfileBookingsCounts = actionFe('feSetClientProfileBookingsCounts');
export const feSetClientProfileData = actionFe('feSetClientProfileData');
export const feSetClientProfileEditData = actionFe('feSetClientProfileEditData');
export const feSetClientProfileSelectedBooking = actionFe('feSetClientProfileSelectedBooking');
export const feSetClientProfileBookingsActiveTab = actionFe('feSetClientProfileBookingsActiveTab');
export const feSetClientProfileMessagesState = actionFe('feSetClientProfileMessagesState');
export const feSetClientProfileOverviewNameHidden = actionFe('feSetClientProfileOverviewNameHidden');
export const feSetClientProfileEditFocusField = actionFe('feSetClientProfileEditFocusField');
